import { useMemo } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { useGetEventQuery, useGetEventTurnoverQuery } from './events.api';
import { TabBar } from 'shared-components';
import { EventDetails } from './event-details';
import { EventAlbums } from './event-albums';
import { EventPricing } from './event-pricing';
import { Form } from 'formik';
import { Archives } from '../archives/archives';
import { Card, CardContent } from 'shared-components';
import { Fact } from '../fact/fact';
import { ShoppingBagIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import { EventProducts } from './event-products';

export const EventForm = () => {
  const currencyFormatter = useMemo(
    () =>
      new Intl.NumberFormat(undefined, { style: 'currency', currency: 'GBP' }),
    []
  );

  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isFetching } = useGetEventQuery(id as string);

  const { data: turnoverData } = useGetEventTurnoverQuery(id as string);
  //const [update, { isLoading: isUpdating }] = useUpdateOrderMutation();

  if (isLoading || isFetching) {
    return <span>loading...</span>;
  }

  if (!data) return <span>Event not found</span>;

  return (
    <>
      <div
        style={{
          marginBottom: '2.25rem',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '1.5rem',
        }}
      >
        <Fact
          title="Total Orders"
          value={turnoverData?.orderCount.toString() ?? '0'}
          icon={<ShoppingBagIcon stroke="#3C50E0" height={22} width={22} />}
        />
        <Fact
          title="Total Spend"
          value={currencyFormatter.format(turnoverData?.total ?? (0 as number))}
          icon={<ShoppingCartIcon stroke="#3C50E0" height={22} width={22} />}
        />
      </div>
      <Card
        style={{
          marginBottom: '1.5rem',
        }}
      >
        <CardContent>
          <TabBar
            tabs={[
              { display: 'Details', link: '', endMatch: true },
              { display: 'Albums', link: 'albums' },
              { display: 'Pricing Overrides', link: 'pricingOverrides' },
              { display: 'Archives', link: 'archives' },
              { display: 'Event Products', link: 'products' },
            ]}
          />
        </CardContent>

        <Form>
          <Routes>
            <Route index element={<EventDetails eventId={id!} />} />
            <Route path="albums" element={<EventAlbums event={data} />} />
            <Route path="pricingOverrides" element={<EventPricing />} />
            <Route
              path="archives"
              element={<Archives eventId={id as string} />}
            />
            <Route path="products" element={<EventProducts />} />
          </Routes>
        </Form>
      </Card>
    </>
  );
};
